<template>
  <div class="home">
    <div class="heredr">
      <div ref="banner" class="banner content-item-block">
        <div class="banner-left">
          <el-carousel :interval="5000" arrow="always" height="450px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <a :href="item.customUrl">
                <img class="img" :src="item.objectKey" alt="" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner-right">
          <div class="Login" v-if="!isLogin">
            <div class="flex-container">
              <span class="flex-left active">个人登录</span>
              <a href="https://clxt.hbcjrjy.cn/" target="_blank">
                <span class="flex-content">企业登录</span>
              </a>
              <a href="https://clxt.hbcjrjy.cn/" target="_blank">
                <span class="flex-right">机构登录</span>
              </a>
            </div>
            <div class="fillout">
              <el-form
                v-if="show"
                ref="userForm"
                :model="userForm"
                :rules="userRules"
                class="login-form"
              >
                <el-form-item prop="phoneNumber">
                  <el-input
                    v-model="userForm.phoneNumber"
                    type="text"
                    maxlength="11"
                    suffix-icon="el-icon-mobile-phone"
                    placeholder="手机号"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="verifyCode">
                  <el-input
                    style="width: 50%"
                    v-model="userForm.verifyCode"
                    type="text"
                    maxlength="6"
                    suffix-icon="el-icon-lock"
                    placeholder="验证码"
                  >
                  </el-input>
                  <el-button
                    style="width: 45%; margin-left: 5%"
                    class="btn-orange"
                    type="primary"
                    :disabled="disabled"
                    @click="getVerifyCode"
                    >{{ valiBtn }}</el-button
                  >
                </el-form-item>
                <el-form-item style="margin-top: -15px">
                  <el-checkbox v-model="checked"
                    >我接受<a
                      :href="'/platformSpecification?platformSpecificationId=1'"
                      target="_blank"
                      style="color: #409eff"
                      >用户服务协议</a
                    >和<a
                      :href="'/platformSpecification?platformSpecificationId=2'"
                      target="_blank"
                      style="color: #409eff"
                      >隐私政策</a
                    ></el-checkbox
                  >
                </el-form-item>
                <el-form-item style="width: 100%">
                  <el-button
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width: 100%"
                    @click.native.prevent="handleUserLogin"
                  >
                    <span v-if="!loading">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                  <div class="login-actions">
                    <!-- Login Method Options -->
                    <div class="login-methods">
                      <div class="method-title">其他登录方式</div>
                      <div class="methods-grid">
                        <el-button
                          class="method-btn"
                          @click="getShow"
                          icon="el-icon-service"
                        >
                          微信登录
                        </el-button>
                        <el-button
                          class="method-btn"
                          @click="getClick"
                          icon="el-icon-lock"
                        >
                          密码登录
                        </el-button>
                      </div>
                    </div>

                    <!-- Divider -->
                    <div class="divider"></div>

                    <!-- Helper Links -->
                    <div class="helper-links">
                      <el-button type="text"
                        ><router-link to="/register"
                          >立即注册</router-link
                        ></el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-button type="text"
                        ><router-link to="/forgotPassword"
                          >忘记密码</router-link
                        ></el-button
                      >
                    </div>
                  </div>
                </el-form-item>
              </el-form>
              <el-form
                v-if="!show"
                ref="userForm"
                :model="userForm"
                :rules="userRules"
                class="login-form"
              >
                <el-form-item prop="phoneNumber">
                  <el-input
                    v-model="userForm.phoneNumber"
                    type="text"
                    maxlength="11"
                    suffix-icon="el-icon-mobile-phone"
                    placeholder="手机号"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="userPassword">
                  <el-input
                    v-model="userForm.userPassword"
                    type="password"
                    suffix-icon="el-icon-lock"
                    placeholder="密码"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item style="margin-top: -15px">
                  <el-checkbox v-model="pwdchecked"
                    >我接受<a
                      :href="'/platformSpecification?platformSpecificationId=1'"
                      target="_blank"
                      style="color: #409eff"
                      >用户服务协议</a
                    >和<a
                      :href="'/platformSpecification?platformSpecificationId=2'"
                      target="_blank"
                      style="color: #409eff"
                      >隐私政策</a
                    ></el-checkbox
                  >
                </el-form-item>
                <el-form-item style="width: 100%">
                  <el-button
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width: 100%"
                    @click.native.prevent="handleRecord"
                  >
                    <span v-if="!loading">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                  <div class="login-actions">
                    <!-- Login Method Options -->
                    <div class="login-methods">
                      <div class="method-title">其他登录方式</div>
                      <div class="methods-grid">
                        <el-button
                          class="method-btn"
                          @click="getShow"
                          icon="el-icon-service"
                        >
                          微信登录
                        </el-button>
                        <el-button
                          class="method-btn"
                          @click="getClick"
                          icon="el-icon-message"
                        >
                          验证码登录
                        </el-button>
                      </div>
                    </div>

                    <!-- Divider -->
                    <div class="divider"></div>

                    <!-- Helper Links -->
                    <div class="helper-links">
                      <el-button type="text"
                        ><router-link to="/register"
                          >立即注册</router-link
                        ></el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-button type="text"
                        ><router-link to="/forgotPassword"
                          >忘记密码</router-link
                        ></el-button
                      >
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="Login" v-else>
            <img
              v-if="profilePhoto"
              :src="profilePhoto"
              alt=""
              class="avatar"
            />
            <img v-else src="../assets/images/tx.jpeg" alt="" class="avatar" />
            <input
              type="file"
              class="file"
              accept=".jpg,.jpeg,.png"
              @change="handleFileChange"
            />
            <div class="userInfo">
              <h4>欢迎您, {{ userName || phoneNumber }} !</h4>
              <span class="state">{{
                functionalStatus == "0"
                  ? "限制"
                  : functionalStatus == "1"
                  ? "正常"
                  : ""
              }}</span>
            </div>
            <ul class="user-tab">
              <router-link to="/resume">
                <li class="tab-item">
                  <div class="rounded-lg bg-blue-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide text-blue-600"
                    >
                      <path
                        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                      ></path>
                      <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                      <path d="M10 9H8"></path>
                      <path d="M16 13H8"></path>
                      <path d="M16 17H8"></path>
                    </svg>
                  </div>
                  <div class="tab-link">
                    我的简历<span class="tab-bolck">{{
                      auditStatus == "0"
                        ? "待审核"
                        : auditStatus == "1"
                        ? "通过"
                        : auditStatus == "2"
                        ? "不通过"
                        : auditStatus == "3"
                        ? "资料未完善"
                        : ""
                    }}</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide-chevron-right-icon"
                  >
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
              </router-link>
              <router-link to="/jobSearchProgress">
                <li class="tab-item">
                  <div class="rounded-lg bg-green-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide text-green-600"
                    >
                      <path d="M16 7h6v6"></path>
                      <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                    </svg>
                  </div>
                  <div class="tab-link">求职进展</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide-chevron-right-icon"
                  >
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
              </router-link>
              <router-link to="/positionSubscription">
                <li class="tab-item">
                  <div class="rounded-lg bg-orange-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide text-orange-600"
                    >
                      <path d="M10.268 21a2 2 0 0 0 3.464 0"></path>
                      <path
                        d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
                      ></path>
                    </svg>
                  </div>
                  <div class="tab-link">岗位订阅</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide-chevron-right-icon"
                  >
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
              </router-link>
              <router-link to="/follow">
                <li class="tab-item">
                  <div class="rounded-lg bg-red-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide text-red-600"
                    >
                      <path
                        d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                      ></path>
                    </svg>
                  </div>
                  <div class="tab-link">关注企业/收藏岗位</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide-chevron-right-icon"
                  >
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
              </router-link>
              <router-link to="/forgotPassword">
                <li class="tab-item">
                  <div class="rounded-lg bg-gray-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide text-gray-600"
                    >
                      <path
                        d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  </div>
                  <div class="tab-link">设置/修改密码</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide-chevron-right-icon"
                  >
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
              </router-link>
            </ul>
            <div class="Exit">
              <el-button class="exit-login" @click="onExit">退出登录</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 活动 -->
      <div class="event" v-if="slides.length > 0">
        <div class="carousel-container">
          <div class="carousel" ref="carousel">
            <div
              class="carousel-track"
              :style="{ transform: `translateX(-${currentPosition}px)` }"
            >
              <div
                v-for="(slide, index) in slides"
                :key="index"
                class="carousel-slide"
              >
                <div
                  class="card"
                  :class="{ active: index === slideIndex }"
                  @mouseenter="slideenter(index)"
                  @mouseleave="slideleave"
                >
                  <a
                    :href="
                      '/zoneDetails?id=' +
                      slide.reRecruitProjectId +
                      '&title=' +
                      slide.title
                    "
                    target="_blank"
                  >
                    <img
                      :src="slide.src"
                      :alt="slide.title"
                      class="card-image"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <button
            class="nav-button prev"
            @click="prev"
            :disabled="currentIndex === 0"
          >
            <i class="arrow left"></i>
          </button>
          <button
            class="nav-button next"
            @click="nexta"
            :disabled="currentIndex >= slides.length - slidesToShow"
          >
            <i class="arrow right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="news-bg">
      <div class="news content-item-block">
        <div class="title">
          <div class="cont_tit">
            <h3>新闻资讯</h3>
          </div>
        </div>
        <ul class="tab">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            class="tab-item"
            :class="{ 'item--active': ModeTab == item.value }"
            @click="toggleLoginModeTab(item.value)"
          >
            <img :src="item.image" alt="" class="image" />{{ item.lable }}
          </li>
        </ul>
        <div data-v-83cea418="" class="news-article flex pt24">
          <div
            data-v-83cea418=""
            class="left"
            style=""
            v-if="ModeTab == 1 && dataList.length < 6"
          >
            <div data-v-83cea418="" style="width: 100%">
              <router-link
                class="item"
                :to="'/content/' + ModeTab + '/' + comment.cmCommentId"
              >
                <div data-v-83cea418="" class="img mb16">
                  <img data-v-83cea418="" :src="comment.objectKey" alt="" />
                </div>
                <h3 data-v-83cea418="" class="link line_clamp2">
                  {{ comment.commentTitle }}
                </h3>
              </router-link>
            </div>
          </div>
          <div style="width: 100%">
            <div class="right flex">
              <router-link
                v-for="(item, index) in dataList"
                :key="index"
                class="item"
                :to="'/content/' + ModeTab + '/' + item.cmCommentId"
              >
                <div data-v-83cea418="" class="title flex">
                  <div
                    data-v-15cfe785=""
                    data-v-83cea418=""
                    class="icon mr14"
                    style="font-size: 20px"
                  >
                    0{{ index + 1 }}
                  </div>
                  <h3 data-v-83cea418="" class="line_clamp1">
                    {{ item.commentTitle }}
                  </h3>
                </div>
                <p data-v-83cea418="" class="line_clamp3">
                  {{ item.outline }}
                </p>
              </router-link>
            </div>
          </div>
        </div>
        <router-link
          class="more"
          :to="{
            path: '/announcement',
            query: { announcementId: ModeTab },
          }"
        >
          <span>{{
            ModeTab == 1
              ? "查看更多新闻动态"
              : ModeTab == 2
              ? "查看更多政策法规 "
              : ModeTab == 3
              ? "查看更多通知公告 "
              : ""
          }}</span>
        </router-link>
      </div>
    </div>
    <!-- 招聘岗位 -->
    <div class="job-category content-item-block">
      <div class="title">
        <div class="cont_tit">
          <h3>招聘岗位</h3>
        </div>
        <div class="crumb">
          <a href="/jobs" target="_blank">
            点击查看更多优质推荐职位<i
              data-v-4b012354=""
              class="el-icon-right animate__infinite animate__animated animate__fadeInLeft"
            ></i>
          </a>
        </div>
      </div>
      <ul class="tab">
        <li
          v-for="(item, index) in tab_post"
          :key="index"
          class="tab-item"
          :class="{ 'item--active': Mode == item.value }"
          @click="toggleLoginMode(item.value)"
        >
          <img :src="item.image" alt="" class="image" />{{ item.lable }}
        </li>
      </ul>
      <ul class="content-list">
        <div v-if="Mode == '1'">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobList"
            :key="index"
          >
            <div class="job-top-container">
              <a :href="'/jobDetail/' + item.jobId" target="_blank">
                <div class="job-top">
                  <h3 class="job-name">
                    {{ item.job }}
                  </h3>
                  <h3 class="wage">{{ item.startSalary }}</h3>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
                <div class="job-bottom substring">
                  <span
                    v-for="(ite, i) in item.disabilities"
                    class="block"
                    :style="{ backgroundColor: getTagColor(ite) }"
                    >{{ ite }}</span
                  >
                </div>
              </a>
            </div>
            <div class="company-bottom">
              <div class="company-desc">
                <a
                  :href="'/companyDetail/' + item.companyId"
                  target="_blank"
                  class="company-t"
                >
                  <img
                    v-if="item.reCompanyLogo"
                    :src="item.reCompanyLogo"
                    :class="{ loaded: imageLoaded }"
                    @load="imageLoaded = true"
                    alt="logo"
                    class="company-logo"
                  />
                  <div
                    v-else
                    class="company-title"
                    :style="{ backgroundColor: getColorById(item.companyId) }"
                  >
                    {{ item.companyName.slice(0, 4) }}
                  </div>
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                </a>
              </div>
            </div>
          </li>
        </div>
        <div v-else-if="Mode == '2'">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobList"
            :key="index"
          >
            <div class="job-top-container">
              <a :href="'/jobDetail/' + item.jobId" target="_blank">
                <div class="job-top">
                  <h3 class="job-name">
                    {{ item.job }}
                  </h3>
                  <h3 class="wage">{{ item.startSalary }}</h3>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
                <div class="job-bottom substring">
                  <span
                    v-for="(ite, i) in item.disabilities"
                    class="block"
                    :style="{ backgroundColor: getTagColor(ite) }"
                    >{{ ite }}</span
                  >
                </div>
              </a>
            </div>
            <div class="company-bottom">
              <div class="company-desc">
                <a
                  :href="'/companyDetail/' + item.companyId"
                  target="_blank"
                  class="company-t"
                >
                  <img
                    v-if="item.reCompanyLogo"
                    :src="item.reCompanyLogo"
                    :class="{ loaded: imageLoaded }"
                    @load="imageLoaded = true"
                    alt="logo"
                    class="company-logo"
                  />
                  <div
                    v-else
                    class="company-title"
                    :style="{ backgroundColor: getColorById(item.companyId) }"
                  >
                    {{ item.companyName.slice(0, 4) }}
                  </div>
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                </a>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <!-- 招聘企业 -->
    <div class="company-bg">
      <div class="company-category content-item-block">
        <div class="title">
          <div class="cont_tit">
            <h3>招聘企业</h3>
          </div>
          <div class="crumb">
            <a href="/companys" target="_blank">
              点击查看更多优质企业<i
                data-v-4b012354=""
                class="el-icon-right animate__infinite animate__animated animate__fadeInLeft"
              ></i>
            </a>
          </div>
        </div>
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in hotCompanyList"
            :key="index"
          >
            <div class="company-bottom company-item">
              <div class="company-desc">
                <a
                  :href="'/companyDetail/' + item.company.reCompanyId"
                  target="_blank"
                  class="company-t"
                >
                  <img
                    v-if="item.company.reCompanyLogo"
                    :src="item.company.reCompanyLogo"
                    alt="logo"
                    class="company-logo1"
                  />
                  <div
                    v-else
                    class="company-title1"
                    :style="{
                      backgroundColor: getColorById(item.company.reCompanyId),
                    }"
                  >
                    {{ item.company.reCompanyName.slice(0, 4) }}
                  </div>
                  <div style="overflow: hidden">
                    <h3 class="company-name substring">
                      {{ item.company.reCompanyName }}
                    </h3>
                    <div class="company-tag substring">
                      <span class="tag" v-if="item.company.industry">{{
                        item.company.industry
                      }}</span
                      ><span class="tag" v-if="item.company.enterpriseNature">{{
                        item.company.enterpriseNature
                      }}</span
                      ><span class="tag" v-if="item.company.enterpriseScale">{{
                        item.company.enterpriseScale
                      }}</span>
                      <span class="tag" v-if="item.company.groupName">{{
                        item.company.groupName
                      }}</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="job-top-container job-item"
              v-for="(ite, index) in item.jobsList.slice(0, 2)"
              :key="index"
            >
              <a :href="'/jobDetail/' + ite.jobId" target="_blank">
                <div class="job-top">
                  <h3 class="job-name">
                    {{ ite.job }}
                  </h3>
                  <h3 class="wage">{{ ite.startSalary }}</h3>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="ite.workingPlace">{{
                    ite.workingPlace
                  }}</span
                  ><span class="tag" v-if="ite.educationName">{{
                    ite.educationName
                  }}</span
                  ><span class="tag" v-if="ite.serviceName">{{
                    ite.serviceName
                  }}</span>
                </div>
                <div class="job-bottom substring">
                  <span
                    v-for="(it, i) in ite.disabilities"
                    class="block"
                    :style="{ backgroundColor: getTagColor(it) }"
                    >{{ it }}</span
                  >
                </div>
              </a>
            </div>
            <a
              :href="'/companyDetail/' + item.company.reCompanyId"
              target="_blank"
              class="link-type"
            >
              更多职位
            </a>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="open"
      width="400px"
      append-to-body
      :before-close="cancel"
      :close-on-click-modal="false"
    >
      <div class="dialog-login" v-loading="loading">
        <div style="margin-bottom: 20px" class="link-type">
          {{ countdown }} 秒后二维码失效
        </div>
        <img class="image" :src="mapSrc" alt="" />
        <div style="margin-top: 20px">
          <el-button type="text" class="link-type" @click="onRefresh"
            >刷新二维码后，重新扫码登录</el-button
          >
        </div>
      </div>
      <div style="text-align: center">
        扫码登录平台，表示你同意<a
          :href="'/platformSpecification?platformSpecificationId=1'"
          target="_blank"
          style="color: #409eff"
          >用户服务协议</a
        >和<a
          :href="'/platformSpecification?platformSpecificationId=2'"
          target="_blank"
          style="color: #409eff"
          >隐私政策</a
        >
      </div>
    </el-dialog>

    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="captchaType"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>
  
  <script>
// @ is an alias to /src
import {
  getUnlimitedQRCode,
  checkSceneLoginStatus,
  getBannerList,
  getCommentListWithPage,
  getPreviewUrl,
  getCaptchaImage,
  sendCode,
  getLatestPositionList,
  getHotPositionList,
  getHotCompanyList,
  personalInfoCommit,
  getReRecruitProjectList,
  getDisabledStatus,
} from "@/api/index.js";
import COS from "cos-js-sdk-v5";
import { mapGetters } from "vuex";
import { getToken, setToken } from "@/helper/auth";
import Verify from "./../components/verifition/Verify";
import {
  getTagColor,
  getColorById,
  formatDisabilityData,
} from "@/helper/utilities";
import { encryptSm4 } from "@/helper/sm4";
import { groupBy } from "lodash";
export default {
  name: "home",
  metaInfo: {
    title: "湖北省残疾人求职招聘信息平台",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { hid: "description", name: "description", content: "网站首页" },
      {
        name: "keywords",
        content: "湖北残联网, 湖北省残疾人求职招聘信息平台",
      },
    ],
  },
  components: {
    Verify,
  },
  data() {
    return {
      URL: "/prod-api",
      //微信扫描
      mapSrc: "",
      scene: "",
      open: false,
      title: "微信登录",
      countdown: 300,
      pollTimer: "",
      timer: null,
      show: false,
      loading: false,
      //大图
      bannerList: [],
      //公告图
      comment: {},
      dataList: [],
      //最热岗位
      hotPositionList: [],
      //最新岗位
      latestPositionList: [],
      jobList: [],
      //热门单位
      hotCompanyList: [],
      captchaType: "",
      valiBtn: "获取验证码",
      disabled: false,
      imageLoaded: false,
      checked: false,
      pwdchecked: false,
      userForm: {
        phoneNumber: "",
        verifyCode: "",
        userPassword: "",
      },
      userRules: {
        phoneNumber: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入请输入合法的手机号",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        userPassword: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 8,
            max: 16,
            message: "用户密码长度必须介于 8 和 16 之间",
            trigger: "blur",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()-+_=,.])[a-zA-Z\d~!@#$%^&*()-+_=,.]{8,16}$/,
            message: "密码必须包含大小写字母，数字，特殊符号",
            trigger: "blur",
          },
        ],
      },
      queryFilter: {
        pageNum: 1,
        pageSize: 6,
        typeIdArr: "1",
        visible: "1",
        orderByColumn: "releaseTime",
        isAsc: "desc",
      },
      // 注册开关
      register: true,
      //公告
      ModeTab: "1",
      tabs: [
        {
          value: "1",
          lable: "新闻动态",
          image: require("@/assets/icon/xwzx.png"),
        },
        {
          value: "2",
          lable: "政策法规",
          image: require("@/assets/icon/zcfg.png"),
        },
        {
          value: "3",
          lable: "通知公告",
          image: require("@/assets/icon/tzgg.png"),
        },
      ],
      //招聘岗位
      Mode: "1",
      tab_post: [
        {
          value: "1",
          lable: "热门岗位",
          image: require("@/assets/icon/rmzw.png"),
        },
        {
          value: "2",
          lable: "最新职位",
          image: require("@/assets/icon/zxzw.png"),
        },
      ],
      //活动滑块
      currentIndex: 0,
      currentPosition: 0,
      slidesToShow: 4,
      slideWidth: 300,
      slideIndex: "",
      slides: [],
    };
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "phoneNumber",
      "userName",
      "profilePhoto",
      "auditStatus",
      "functionalStatus",
    ]),
  },
  created() {
    this.getPersonalInfo();
    this.BannerList();
    this.CommentList(this.ModeTab);
    this.HotPositionList();
    this.HotCompanyList();
    this.RegionList();
  },
  methods: {
    getTagColor,
    getColorById,
    //随机生成32位动态码
    generateRandomString(length) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    //刷新二维码
    onRefresh() {
      this.countdown = 300;
      clearInterval(this.pollTimer);
      clearInterval(this.timer);
      this.getShow();
    },

    //打开二维码弹窗
    getShow() {
      this.scene = this.generateRandomString(32);
      this.open = true;
      this.loading = true;
      this.UnlimitedQRCode();
      this.startCountdown();
      this.startPolling();
    },
    //获取二维码图片
    UnlimitedQRCode() {
      getUnlimitedQRCode(this.scene).then((res) => {
        this.loading = false;
        let blob = new Blob([res]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.mapSrc = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
      });
    },

    //二维码失效计时器
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.$message.warning("二维码已过期");
          return;
        }
        this.countdown--;
      }, 1000);
    },

    //轮询查询是否扫描登入成功
    async startPolling() {
      const poll = async () => {
        try {
          await checkSceneLoginStatus(this.scene).then((res) => {
            if (res.code == 200) {
              clearInterval(this.pollTimer);
              clearInterval(this.timer);
              setToken(res.data.token);
              this.$store.commit("SET_TOKEN", res.data.token);
              this.$store.commit("SET_STATUS", "true");
              this.$store.commit("SET_PHONENUMBER", res.data.phoneNumber);
              this.$message({
                showClose: true,
                message: "登录成功",
                type: "success",
              });
              this.getPersonalInfo();
              this.open = false;
            }
          });
        } catch (error) {
          console.error("轮询异常:", error);
        }
      };

      this.pollTimer = setInterval(poll, 3000);
      poll(); // 立即执行第一次
    },

    // 取消弹窗
    cancel() {
      this.open = false;
      this.countdown = 300;
      clearInterval(this.pollTimer);
      clearInterval(this.timer);
    },

    updatePosition() {
      this.currentPosition = this.currentIndex * this.slideWidth;
    },

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updatePosition();
      }
    },
    nexta() {
      if (this.currentIndex < this.slides.length - this.slidesToShow) {
        this.currentIndex++;
        this.updatePosition();
      }
    },

    //移入
    slideenter(index) {
      this.slideIndex = index;
    },

    //移出
    slideleave() {
      this.slideIndex = null;
    },

    //活动专区列表
    async RegionList() {
      await getReRecruitProjectList().then((res) => {
        if (res.code == 200) {
          res.data.forEach(async (item, i) => {
            if (item.visible == 1) {
              this.slides.push({
                reRecruitProjectId: item.reRecruitProjectId,
                src: "",
                title: item.projectName,
                num: item.count,
              });
              await this.PreviewUrlRegion(item, i);
            }
          });
        }
      });
    },

    async PreviewUrlRegion(item, i) {
      await getPreviewUrl(item.webProjectPic).then((response) => {
        this.slides[i].src = response.msg;
      });
    },

    //岗位tab
    toggleLoginMode(mode) {
      this.Mode = mode;
      if (mode == "1") {
        this.HotPositionList();
      } else if (mode == "2") {
        this.LatestPositionListe();
      }
    },

    //最热岗位
    HotPositionList() {
      getHotPositionList().then(async (response) => {
        if (response.code == 200) {
          // 1. 提取所有 jobId
          let jobIds = response.data.map((item) => item.jobId);
          // 2. 根据 jobIds 异步获取残疾标签数据
          await this.fetchDisabilityLabels(response.data, jobIds, 1);
        }
      });
    },

    //最新岗位
    LatestPositionListe() {
      getLatestPositionList().then(async (response) => {
        if (response.code == 200) {
          // 1. 提取所有 jobId
          let jobIds = response.data.map((item) => item.jobId);
          // 2. 根据 jobIds 异步获取残疾标签数据
          await this.fetchDisabilityLabels(response.data, jobIds, 1);
        }
      });
    },

    //3，获取对应数据的残疾标签
    fetchDisabilityLabels(dataList, jobIds, state) {
      if (jobIds.length > 0) {
        getDisabledStatus(jobIds).then((res) => {
          const result = {};
          Object.keys(res.data).forEach((jobId) => {
            const grouped = groupBy(res.data[jobId], "disabledType");
            result[jobId] = Object.entries(grouped).map(([type, items]) => ({
              disabledType: type,
              disabledLevel: [
                ...new Set(items.map((item) => item.disabledLevel)),
              ],
            }));
          });

          const formattedData = formatDisabilityData(result);
          if (state == 1) {
            this.jobList = dataList.map((job, i) => {
              if (job.reCompanyLogo) {
                this.PreviewLogoUrl(job.reCompanyLogo, i);
              }
              // 找到当前jobId对应的残疾数据
              const disabilities = formattedData[job.jobId] || [];
              return {
                ...job,
                disabilities, // 将残疾数据添加到职位对象中
              };
            });
          } else if (state == 2) {
            for (let i = 0; i < this.hotCompanyList.length; i++) {
              for (let j = 0; j < dataList.length; j++) {
                if (
                  this.hotCompanyList[i].company.reCompanyId ==
                  dataList[j].companyId
                ) {
                  this.hotCompanyList[i].jobsList = dataList.map((job) => {
                    // 找到当前jobId对应的残疾数据
                    const disabilities = formattedData[job.jobId] || [];
                    return {
                      ...job,
                      disabilities, // 将残疾数据添加到职位对象中
                    };
                  });
                }
              }
            }
          }
        });
      }
    },

    //获取岗位列表公司logo
    async PreviewLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.jobList[i].reCompanyLogo = response.msg;
      });
    },

    //最热单位
    HotCompanyList() {
      getHotCompanyList().then(async (response) => {
        if (response.code == 200) {
          this.hotCompanyList = response.data;
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].company.reCompanyLogo) {
              await this.PreviewCompanyLogoUrl(
                response.data[i].company.reCompanyLogo,
                i
              );
            }
            // 1. 提取所有 jobId
            let jobIds = response.data[i].jobsList.map((item) => item.jobId);
            // 2. 根据 jobIds 异步获取残疾标签数据
            await this.fetchDisabilityLabels(
              response.data[i].jobsList,
              jobIds,
              2
            );
          }
        }
      });
    },

    //获取公司logo
    async PreviewCompanyLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.hotCompanyList[i].company.reCompanyLogo = response.msg;
      });
    },

    //获取大图
    async BannerList() {
      await getBannerList().then((response) => {
        response.data.forEach(async (item, i) => {
          if (item.visible == 1) {
            this.bannerList.push({
              objectKey: "",
              customUrl: item.customUrl,
              visible: item.visible,
            });
            await this.PreviewUrl(item, i);
          }
        });
      });
    },

    async PreviewUrl(item, i) {
      await getPreviewUrl(item.objectKey).then((response) => {
        this.bannerList[i].objectKey = response.msg;
      });
    },

    toggleLoginModeTab(mode) {
      this.ModeTab = mode;
      this.queryFilter.typeIdArr = mode;
      this.CommentList(mode);
    },

    //获取公告
    CommentList(mode) {
      getCommentListWithPage(this.queryFilter).then((res) => {
        if (res.code == 200) {
          if (mode == 1) {
            if (res.rows[0].objectKey && res.rows[0].coverImageVisible == "1") {
              this.dataList = res.rows.slice(1).slice(0, -1);
              this.PreviewUrl1(res.rows[0]);
            } else {
              this.dataList = res.rows;
            }
          } else {
            this.dataList = res.rows;
          }
        }
      });
    },

    PreviewUrl1(item) {
      getPreviewUrl(item.objectKey).then((response) => {
        this.comment = item;
        this.comment.objectKey = response.msg;
      });
    },

    success(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.tackBtn(); //验证码倒数60秒
      this.$set(params, "phoneNumber", this.userForm.phoneNumber);
      sendCode(params).then((res) => {});
    },

    //获取验证码 并只验证手机号 是否正确
    getVerifyCode() {
      let isValid = true;
      this.$refs["userForm"].validateField(["phoneNumber"], (err) => {
        if (err) {
          isValid = false;
          console.log("未通过");
          return;
        } else {
          console.log("已通过");
        }
      });
      if (isValid) {
        this.captchaType = Math.random() < 0.5 ? "blockPuzzle" : "clickWord";
        this.$refs.verify.show();
      }
    },

    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },

    //切换登录方式
    getClick() {
      this.show = !this.show;
    },

    //验证码登录
    handleUserLogin() {
      if (this.checked) {
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            let postBody = {
              phoneNumber: this.userForm.phoneNumber,
              verifyCode: encryptSm4(this.userForm.verifyCode),
            };
            this.$store
              .dispatch("verifyCodeLogin", postBody)
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    showClose: true,
                    message: "登录成功",
                    type: "success",
                  });
                  this.getPersonalInfo();
                  this.loading = false;
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: "warning",
                  });
                  this.loading = false;
                }
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
      } else {
        this.$message.error("阅读并勾选用户服务协议和隐私政策");
      }
    },

    //密码登录
    handleRecord() {
      if (this.pwdchecked) {
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            let postBody = {
              phoneNumber: this.userForm.phoneNumber,
              userPassword: encryptSm4(this.userForm.userPassword),
            };
            this.$store
              .dispatch("Login", postBody)
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    showClose: true,
                    message: "登录成功",
                    type: "success",
                  });
                  this.getPersonalInfo();
                  this.loading = false;
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: "warning",
                  });
                  this.loading = false;
                }
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
      } else {
        this.$message.error("请先阅读并勾选用户服务协议和隐私政策");
      }
    },

    //获取个人信息
    getPersonalInfo() {
      if (getToken()) {
        this.getUserOpen();
        this.$store.dispatch("GetInfo").then((res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              if (res.data.reMiniProgramPerson.profilePhoto) {
                this.PreviewUrlPhoto(res.data.reMiniProgramPerson.profilePhoto);
              }
            }
          }
        });
      }
    },

    //获取头像
    PreviewUrlPhoto(profilePhoto) {
      this.$store.dispatch("PreviewUrlPhoto", profilePhoto);
    },

    getUserOpen() {
      this.$store.dispatch("GetUserOpen");
    },

    // 退出登录
    onExit() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.href = "/home";
      });
    },

    //上传头像
    handleFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        let types = input.files[0].name.split(".")[1];
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 1) {
          this.uploads(files, types);
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过1M！",
          });
        }
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    generateUUID() {
      var d = new Date().getTime(); //Timestamp
      var d2 =
        (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },

    //上传
    uploads(files, types) {
      let _this = this;
      _this.showLoading();
      let uuid = _this.generateUUID();
      let objectKey = "湖北省残疾人求职招聘信息平台/头像/" + uuid + "." + types;
      // 初始化实例
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = _this.URL + "/api/miniProgram/getCosAuth";
          const xhr = new XMLHttpRequest();
          xhr.open("get", url, true);
          xhr.onload = function (e) {
            let data = JSON.parse(xhr.response).data;
            let timestamp = Math.floor(data.startTime / 1000);
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              SecurityToken: data.sessionToken,
              StartTime: timestamp, // 时间戳，单位秒，如：1580000000
              ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });

      cos.uploadFile(
        {
          Bucket: "zhaopin-1322091753" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: files, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            10 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err) {
            _this.load.close();
            _this.$message.error("上传失败");
          } else {
            let obj = {
              miniProgramPersonId: _this.miniProgramPersonId,
              profilePhoto: objectKey,
            };
            personalInfoCommit(obj)
              .then((res) => {
                if (res.code == 200) {
                  _this.load.close();
                  _this.getPersonalInfo();
                  _this.$message({
                    type: "success",
                    message: "上传成功!",
                  });
                } else {
                  _this.load.close();
                  _this.$message(res.msg);
                }
              })
              .catch(() => {
                _this.load.close();
              });
          }
        }
      );
    },
  },
};
</script>
  
<style lang="less" scoped>
@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.animate__animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  margin-left: 10px;
}
.animate__fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}
.animate__animated.animate__infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

::v-deep .el-card__body {
  padding: 0 20px;
}

::v-deep .el-form-item:nth-child(3) {
  margin-bottom: 5px;
}

::v-deep .el-checkbox {
  margin-left: -70px;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #66716c;
}

.dialog-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    width: 200px;
  }
}

.home {
  .content-item-block {
    .title {
      font-size: @font-size-larger;
    }
  }
}

//导航
.banner {
  min-height: 450px;
  width: @main-width;
  margin: auto;
  display: flex;
  position: relative;
  margin-top: 10px;
  .banner-left {
    margin-right: 20px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    width: 850px;
    border-radius: 5px;
    .img {
      width: 850px;
      height: 450px;
    }
  }
  .banner-right {
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    box-sizing: content-box;
    padding: 0 20px;
    width: 290px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    .Login {
      width: 290px;
      text-align: center;
      position: relative;
      .flex-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        font-size: 16px;
        .flex-left {
          width: 80px;
          line-height: 40px;
          text-align: center;
        }

        .flex-content {
          width: 80px;
          line-height: 40px;
          text-align: center;
          display: inline-block;
        }

        .flex-right {
          width: 80px;
          line-height: 40px;
          text-align: center;
          display: inline-block;
        }

        .active {
          line-height: 38px;
          border-bottom: 2px solid #00a0e9;
        }
      }

      .avatar {
        border-radius: 50%;
        height: 80px;
        margin-bottom: 20px;
        -o-object-fit: contain;
        object-fit: contain;
        width: 80px;
      }

      .file {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        z-index: 15;
        width: 80px;
        height: 80px;
        left: 80px;
      }

      .userInfo {
        text-align: center;
        font-size: 20px;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .state {
          font-size: 14px;
          margin-left: 10px;
          display: inline-block;
          background: #00a0e9;
          padding: 2px 5px;
          color: #fff;
          border-radius: 15px;
        }
      }

      .link-type {
        color: #337ab7;
        font-size: 14px;
      }

      .user-tab {
        .tab-item {
          font-size: 16px;
          font-weight: 500;
          height: 45px;
          line-height: 45px;
          text-align: left;
          padding-left: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tab-link {
            width: 200px;
          }
          .tab-bolck {
            font-size: 12px;
            margin-left: 10px;
            display: inline-block;
            background-color: rgb(145, 220, 172);
            padding: 0px 5px;
            color: #fff;
            border-radius: 5px;
            height: 20px;
            line-height: 20px;
          }
          .rounded-lg {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            border-radius: 5px;
            margin-right: 10px;
          }
          .lucide {
            width: 16px;
            height: 16px;
          }
          .bg-blue-100 {
            background-color: rgb(218, 233, 252);
            .text-blue-600 {
              color: rgb(36, 96, 224);
            }
          }
          .bg-green-100 {
            background-color: rgb(223, 255, 234);
            .text-green-600 {
              color: rgb(22, 162, 73);
            }
          }
          .bg-orange-100 {
            background-color: rgb(255, 237, 213);
            .text-orange-600 {
              color: rgb(234, 88, 12);
            }
          }
          .bg-red-100 {
            background-color: rgb(254 226 226);
            .text-red-600 {
              color: rgb(220 38 38);
            }
          }
          .bg-gray-100 {
            background-color: rgb(243, 244, 246);
            .text-gray-600 {
              color: rgb(75, 85, 99);
            }
          }
          .lucide-chevron-right-icon {
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
        }
        .tab-item:hover {
          color: #00a0e9;
          background-color: rgba(23, 85, 243, 0.1);
          border-radius: 5px;
        }
      }

      .Exit {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid rgb(226, 229, 236);
        .exit-login {
          width: 80%;
          background: #e3e6e5;
          border-radius: 10px;
        }
      }

      .login-code {
        width: 45%;
        height: 38px;
        float: right;
        margin-left: 5%;

        img {
          cursor: pointer;
          vertical-align: middle;
          width: 100%;
          height: 40px;
        }
      }

      .login-actions {
        margin-top: 20px;
        border-top: 1px solid #f0f0f0;
        .login-methods {
          margin-bottom: 16px;
          .method-title {
            font-size: 14px;
            color: #999;
            margin-bottom: 10px;
            text-align: center;
          }

          .methods-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;
            .method-btn {
              background: #f5f7fa;
              border: 1px solid #dcdfe6;
              color: #606266;
              transition: all 0.3s ease;
            }

            .method-btn:hover {
              border-color: #409eff;
              color: #409eff;
              background: #f0f9ff;
            }

            .method-btn ::v-deep .el-icon {
              margin-right: 4px;
            }
          }
        }
        /* Divider */
        .divider {
          height: 1px;
          background: #f0f0f0;
          margin: 12px 0;
        }
        /* Helper links section */
        .helper-links {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0;
        }

        .helper-links ::v-deep .el-button--text {
          color: #606266;
          font-size: 14px;
          padding: 0 8px;
        }

        .helper-links ::v-deep .el-button--text:hover {
          color: #409eff;
        }

        .helper-links ::v-deep .el-divider--vertical {
          height: 14px;
          margin: 0 4px;
        }
      }
    }
  }
}

// 活动专区
.event {
  width: @main-width;
  margin: auto;
  overflow: hidden;
  padding: 2% 0;
  .carousel-container {
    position: relative;
    width: 100%;
    .carousel {
      width: 100%;
      overflow: inherit;
      .carousel-track {
        display: flex;
        transition: transform 0.5s ease-in-out;
        .carousel-slide {
          flex: 0 0 auto;
          width: calc(100% / 3.95);
          padding-right: 20px;
          .card {
            position: relative;
            border-radius: 12px;
            overflow: hidden;
            aspect-ratio: 2;
            transition: transform 0.5s ease;
            .card-image {
              width: 100%;
              height: 100%;
            }
          }
          .card.active {
            transform: translate(-1%, -1%) scale(1.1);
            transition: transform 0.5s ease;
          }
        }
      }
    }
    .nav-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.8);
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      .arrow {
        border: solid #333;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
      }

      .arrow.left {
        transform: rotate(135deg);
      }

      .arrow.right {
        transform: rotate(-45deg);
      }
    }

    .nav-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .nav-button.prev {
      left: 20px;
    }

    .nav-button.next {
      right: 20px;
    }
  }
}

//新闻资讯
.news-bg {
  width: 100%;
  background: #f6faf8 url(../assets/images/xwbg.png) no-repeat;
  .news {
    .pt24 {
      padding-top: 24px;
    }
    .flex {
      display: flex;
    }
    .news-article {
      .left {
        width: 376px;
        margin-right: 40px;
        .img {
          width: 376px;
          height: 162px;
          background: #d8d8d8;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 16px;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            object-fit: cover;
            transition: all 0.5s ease 0.1s;
          }
        }
        .line_clamp2 {
          font-size: 18px;
          color: #1f2924;
          line-height: 26px;
          text-align: left;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
        }
        .line_clamp2:hover {
          color: #00a0e9;
        }
      }
      .right {
        flex: 1;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
          width: 368px;
          margin-bottom: 25px;
          .title {
            margin-bottom: 28px;
            .icon {
              position: relative;
              color: #00a0e9;
              font-weight: 800;
            }
            .icon:after {
              width: 6px;
              right: 0;
            }
            .icon:before {
              width: 14px;
            }
            .icon:after,
            .icon:before {
              position: absolute;
              content: "";
              display: block;
              height: 4px;
              background: rgba(31, 41, 36, 0.2);
              border-radius: 2px;
              bottom: -10px;
            }
            .mr14 {
              margin-right: 14px;
            }
            .line_clamp1 {
              font-size: 18px;
              color: #1f2924;
              line-height: 26px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;
              -webkit-line-clamp: 1;
            }
            .line_clamp1:hover {
              color: #00a0e9;
            }
          }
          .line_clamp3 {
            font-size: 16px;
            color: #4b534f;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;
            -webkit-line-clamp: 2;
            text-align: left;
          }
        }
      }
    }
    .more {
      display: block;
      width: 100%;
      height: 48px;
      border-radius: 8px;
      border: 1px solid rgba(31, 41, 36, 0.1);
      font-size: 16px;
      color: #787e7b;
      line-height: 48px;
      text-align: center;
      cursor: pointer;
    }
  }
}

// 职位
.news,
.job-category {
  width: @main-width;
  margin: auto;
  text-align: center;
  padding: 2% 0;
  .tab {
    display: -ms-flexbox;
    display: flex;
    height: 45px;
    justify-content: center;
    align-items: center;
    line-height: 45px;
    margin-bottom: 20px;
    margin-top: 2%;
    text-align: center;
    .tab-item {
      color: #333;
      font-size: 18px;
      margin: 0 40px;
      width: 136px;
      border-radius: 22px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .image {
        width: 22px;
        height: 22px;
        margin-right: 5px;
      }
    }
    .tab-item.item--active {
      background: #00a0e9;
      color: #fff;
      .image {
        filter: brightness(0) invert(1); /* 变白色 */
      }
    }
  }
  .content-list > div {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}

.crumb {
  display: block;
  text-align: center;
  font-size: 18px;
  color: #e9951e !important;
  line-height: 26px;
  text-shadow: 0 25px 37px rgba(31, 41, 36, 0.1);
  margin-top: 16px;
}

.recommend-job-item:nth-child(3n) {
  margin-right: 0;
}
.recommend-job-item {
  background-color: #fff;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  margin-bottom: 21px;
  margin-right: 21px;
  padding: 13px 23px;
  width: 340px;
}

// 公司

.company-bg {
  width: 100%;
  background: #f6faf8 url(../assets/images/company_bg.png) no-repeat;
  .company-category {
    width: @main-width;
    margin: auto;
    text-align: center;
    padding: 2% 0;
    // margin-top: 25px;
    .content-list {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      // margin-top: 20px;
      margin-top: 2%;
      .company-item {
        border-bottom: 1px dotted #666;
        padding-bottom: 10px;
      }
      .job-item {
        padding-top: 10px;
      }
      .link-type {
        color: #337ab7;
        margin-top: 10px;
        font-size: 16px;
        width: 150px;
        height: 40px;
        border: 1px solid #337ab7;
        border-radius: 45px;
        line-height: 40px;
        display: inline-block;
      }
    }
  }
}
</style>
  